import { useEffect } from 'react'
import Head from 'components/o_series/common/Head'

const PolicyTemplate: React.FC = ({ children }) => {
  useEffect(() => {
    document.body.classList.add('bg-green-800')

    return () => document.body.classList.remove('bg-green-800')
  })

  const renderBubblesDesktop = () => {
    // Desktop only
    return (
      <div className="hidden md:block relative">
        <div className="absolute -z-1 -left-12 -top-12 bg-blue rounded-full h-48 w-48" />
        <div className="absolute -z-1 right-48 -top-4 bg-blue rounded-full h-14 w-14" />
        <div className="absolute -z-1 -right-24 top-36 bg-blue rounded-full h-48 w-48" />
        <div className="absolute -z-1 -left-4 top-72 bg-blue rounded-full h-8 w-8" />
      </div>
    )
  }

  const renderBubblesBot = () => {
    return (
      <div className="hidden md:block relative">
        <div className="absolute -z-1 left-24 bottom-32 bg-blue rounded-full h-8 w-8" />
        <div className="absolute -z-1 right-24 bottom-48 bg-blue rounded-full h-14 w-14" />
      </div>
    )
  }

  return (
    <>
      <Head />
      <div className="overflow-x-hidden">
        {renderBubblesDesktop()}
        <div className="px-2 md:px-7 container mx-auto pb-24">
          <div className="min-h-screen">
            <header className="flex justify-center pt-7 mb-7">
              <img
                width="110"
                height="80"
                src="/assets/o_series/landing/logo.svg"
              />
            </header>
            <main className="flex flex-col bg-white rounded-lg p-5 md:p-10 font-helvetica font-base">
              <h3 className="text-lg font-bold text-left mb-5">
                Please contact our friendly customer support for any questions
                or comments:
              </h3>
              <p className="text-left mb-5">
                <br />
                <span className="mb-4">
                  <strong>E-mail: </strong>hello@ketogo.app
                </span>
                <br />
                <span className="mb-4">
                  <strong>Company information: </strong>Nutrameg SIA, registration
                  number: 50203370651, VAT number: LV50203370651, legal address:
                  Lastadijas street 6, Riga, LV-1050, Latvia
                </span>
              </p>
              {children}
            </main>
          </div>
        </div>
        {renderBubblesBot()}
      </div>
    </>
  )
}

export default PolicyTemplate
